import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const testimonials = [{
  name: 'María, 43 años',
  quote: 'En la primera semana ya dormía mejor. No podía creer que algo tan simple funcionara tan rápido.',
  avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/6cdf4d00-3163-4ccb-ac6b-1e94e522f644.jpg'
}, {
  name: 'Laura, 38 años',
  quote: 'Llevaba 2 años sintiéndome inflamada y sin energía. En 30 días noté un cambio real en mi cuerpo.',
  avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/61dcea4d-c818-41b3-b8f1-16460220ccb7.jpg'
}, {
  name: 'Carolina, 47 años',
  quote: 'El método es suave, sin sacrificios extremos. Por fin algo que puedo sostener en el tiempo.',
  avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/fd516b36-4691-4bf9-8364-a6b3a8b42e07.jpg'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-white py-20 sm:py-28" data-id="element-184" data-mp="32egal09shgij">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-185" data-mp="2v09mul26kw32">
        <Reveal className="mx-auto max-w-2xl text-center" data-id="element-186" data-mp="2q2rccq8im8sy">
          <h2 className="font-serif text-3xl font-semibold text-tinta sm:text-4xl lg:text-5xl" data-id="element-187" data-mp="2q27uf9iv7kex">
            Lo que dicen las mujeres que ya comenzaron
          </h2>
        </Reveal>

        <ul className="mt-12 grid gap-6 md:grid-cols-3" data-id="element-188" data-mp="2ztlyzvpobaex">
          {testimonials.map((t, i) => <Reveal as="li" key={t.name} delay={i * 0.1} data-id="element-189" data-mp="2c3hxpuzyjmr3" data-mpi={i}>
              <figure className="flex h-full flex-col rounded-3xl border border-nude/70 bg-crema/50 p-7 shadow-sm" data-id="element-190" data-mp="273vjpjcb22h8">
                <div className="flex items-center gap-4" data-id="element-191" data-mp="2m163dfz3qeo1">
                  <img src={t.avatar} alt="" className="h-14 w-14 shrink-0 rounded-full object-cover" loading="lazy" data-id="element-192" data-mp="2lyjn8ry5aqu7" />
                  <figcaption className="font-serif text-lg font-semibold text-tinta" data-id="element-193" data-mp="3sh8dhz0fvzgk">
                    {t.name}
                  </figcaption>
                </div>

                <div className="mt-5 flex items-center gap-1" role="img" aria-label="5 de 5 estrellas" data-id="element-194" data-mp="3gv7mcml2kph">
                  {Array.from({
                length: 5
              }).map((_, star) => <StarIcon key={star} className="h-4 w-4 fill-dorado text-dorado" strokeWidth={1.5} aria-hidden="true" data-id="element-195" data-mp="ickvyhf8r9xd" data-mpi={star} />)}
                </div>

                <blockquote className="mt-4 text-base leading-relaxed text-tinta/75" data-id="element-196" data-mp="3qruuxgnu3z0x">
                  “{t.quote}”
                </blockquote>
              </figure>
            </Reveal>)}
        </ul>

        <Reveal delay={0.15} data-id="element-197" data-mp="2y3ffwu4pdgpl">
          <p className="mt-10 text-center text-sm text-rosa-dark" data-id="element-198" data-mp="2y24gf6iaiv4a">
            Más de 200 mujeres ya comenzaron su transformación hormonal
          </p>
        </Reveal>
      </div>
    </section>;
}